export default __webpack_public_path__ + "assets/multi-imagem-component.ea5a1def.svg";